<template lang="pug">
dialog.video-library-dialog(:id="result.key" @keypress.esc.prevent="closeModal()")
    button.video-library-dialog__close(@click="closeModal()" aria-label="Close Modal") 
        i.fas.fa-times
    .video-player.is-active
        .video-player__video
            iframe(:src="`https://www.youtube.com/embed/${this.videoCode}?autoplay=1&color=white&autohide=2&modestbranding=1&border=0&wmode=opaque&enablejsapi=1&showinfo=0&rel=0`" title='YouTube video player' frameborder='0' allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture' allowfullscreen='')
        a.video-library-dialog__title(:href="result.url") {{ result.title }}
        .video-library-dialog__description {{ result.meta.shortDescription }}
</template>
<script>
export default {
    name: "VideoLibraryResultsItemDialog",
    props: ["result"],
    computed: {
        videoCode() {
            return this.result.meta.videoembedcode;
        }
    },
    data () {
        return {
            open: false
        }
    },
    methods: {
        closeModal() {
            
            this.$el.classList.remove('is-active')
            setTimeout(() => {
                // probably unnecessary with the $emit
                this.$el.close()
                this.$emit('close')
            }, 350)
            
        }
    },
    mounted() { 
        const root = this;
        root.$el.showModal();

        setTimeout(() => {
            root.$el.classList.add('is-active');

            //Fire tracking event
            if (root.$root.options.activityEndpoint && root.result.nodeId) {
                fetch(root.$root.options.activityEndpoint, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        "NodeId": root.result.nodeId,
                        "Title": root.result.title,
                        "ContactGuid": getCookie('CurrentContact'),
                        "Url": root.result.url,
                        "EmbedCode": root.embedCode
                    })
                })
            }
        }, 350)
        // this.showModal()
    }
};      

function getCookie(name) {
  return document.cookie.split("; ").find((c) => c.startsWith(`${name}=`))?.split("=")[1];
}
</script>

<style lang="scss" scoped>
.video-library-dialog {
  padding: 0;
  overflow: inherit;

  &__close {
    color: white;
    z-index: 1;
    font-size: 1.5em;
    margin: -1.5em -0.25em;
    &:hover {
      color: #00bab3;
    }
  }

  a.video-library-dialog__title {
    color: $black !important;

    &:hover {
        color: $occBlue !important;
    }
  }
}
</style>